import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'

const unsupportedFlowTypes = [
  FlowType.BORROW_ONBOARDING,
  FlowType.BUSINESS_ACCOUNT_CREATION, // https://block.atlassian.net/browse/CASHW-3742
  FlowType.CLOSE_MONEY_POOL,
  FlowType.CREATE_OR_EDIT_RECURRING_PAYMENT,
  FlowType.INITIATE_CLAIM,
  FlowType.VIEW_AP_PAYMENT_PLAN_FLOW,
  FlowType.VIEW_PAYMENT_PLAN_FLOW, // https://block.atlassian.net/browse/CASHW-3741
  FlowType.VIEW_MONEY_POOL,
  'P2P_REPORT_SCAM', // does not exist on FlowType proto
]

export const unsupportedFlowRoutes = unsupportedFlowTypes.flatMap(type => [
  {
    id: `flow-unsupported-${type}`,
    trackingName: `Flow Unsupported ${type}`,
    path: `dl/flow/${type}`,
    handle: { unsupported: true },
  },
  {
    id: `flow-type-unsupported-${type}`,
    trackingName: `Flow Type Unsupported ${type}`,
    path: `dl/flow/type/${type}`,
    handle: { unsupported: true },
  },
])
